import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import UserService from "../../api-service/UserService";
import {
  ERROR_WHILE_UPDATING_PROFILE_PICTURE,
  PROFILE_UPDATED_SUCCESSFULLY,
} from "../../configurations/MessageConstants";
import {
  DANGER,
  EMPTY,
  INFO,
  SESSION_EXPIRED,
  SESSION_EXPIRED_MESSAGE,
} from "../../configurations/Constants";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../configurations/redux-configurations/actions/userAction";
import StorageHelper from "../../helpers/StorageHelper";
import {
  SESSION_HAS_EXPIRED,
  INCOMING_TOKEN_HAS_EXPIRED,
} from "../../configurations/MessageConstants";
import SessionHelper from "../../helpers/SessionHelper";
import { StatusCodes } from "../../configurations/status-codes";

function RemovePicturePopup({ show, onClose, handleAlert }) {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user.userInfo);
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    onClose();
  };

  const handleRemovePhoto = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("profile_pic", EMPTY);

    try {
      await UserService.updateProfileInfo(formData);
      handleAlert(PROFILE_UPDATED_SUCCESSFULLY, INFO);
      dispatch(
        setUserDetails({
          ...userInfo,
          profile_pic: EMPTY,
        })
      );
    } catch (error) {
      const responseData = error.response.data;
      console.error(ERROR_WHILE_UPDATING_PROFILE_PICTURE, error);
      if (
        error.response.status === StatusCodes.UNAUTHORIZED &&
        responseData.message.includes(INCOMING_TOKEN_HAS_EXPIRED)
      ) {
        StorageHelper.setItem(SESSION_EXPIRED, true);
        StorageHelper.setItem(SESSION_EXPIRED_MESSAGE, SESSION_HAS_EXPIRED);
        SessionHelper.cleanUpStorageKeys();
        window.location.reload();
      } else {
        handleAlert(responseData.message, DANGER);
      }
    } finally {
      setLoading(false);
      handleCancel();
    }
  };

  return (
    <Modal show={show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Remove Profile Picture</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to remove your profile picture?</span>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleRemovePhoto}
          disabled={loading}
        >
          {loading ? "Removing..." : "Remove"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RemovePicturePopup;
